import React, { PropTypes, Component } from 'react'
import { connect } from 'react-redux';
import ScrollingResorts from './scrollingresorts';
import SliderResorts from './sliderresorts';
import topics from './topics'
const Resorts = () => {
      return( <div>
          { topics.map(topic => <ScrollingResorts key={topic.id} topic={ topic.id }/>) } 
              </div> )

  //? ( this.props.browser.greaterThan.small ? <SliderResorts /> : <ScrollingResorts/>  )
        // return this.props.browser
        //   ? ( this.props.browser.greaterThan.small ? <ScrollingResorts/> : <ScrollingResorts/>  )
        //     : ( <div></div> )
}

export default connect( 
    state =>({
        browser: state.browser,
    }),
    dispatch => { 
        return { 
        } 
    }
)(Resorts);



// WEBPACK FOOTER //
// ./src/components/homescreen/resorts/index.js